import { Component, Input, OnInit } from '@angular/core';
import { LocalLoadEvent } from '../../../shared/local-load-event.model';

@Component({
  selector: 'app-load-event-note-creation',
  templateUrl: './load-event-note-creation.component.html',
  styleUrls: ['./load-event-note-creation.component.scss']
})
export class LoadEventNoteCreationComponent implements OnInit {

  @Input()
  event: LocalLoadEvent;

  constructor() {
  }

  ngOnInit() {
  }

}
